import { Component, HostListener, Inject } from "@angular/core";
import { QuotesServiceProvider, RouteDataProvider, AlertService, RequestHelperProvider, ItemServiceProvider, StorageServiceProvider, DialogCloseService } from "./../../_services/services";
import { Global } from 'src/app/globals';
import utils from './../../utils';
import * as Sentry from '@sentry/angular';
import { ASRAppSettings, PendingAgreementsConfiguration, StorageKeys } from 'src/app/_constants';
import { PendingAgreementConfig } from 'src/app/_models/booking/pending-agreement-config';
import { AppSettingsServiceProvider } from '../../_services/app-settings.service';
import { ItemRequest } from "src/app/_models/item/item-request.model";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Title } from "@angular/platform-browser";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { Router } from "@angular/router";
import { LoadingService } from "src/app/_services/loading.service";

@Component({
    templateUrl: './quotes.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ],
})
export class QuotesComponent {

    panelOpenState = false;
    quoteSearch: String = "";
    quotes: any = [];
    selectedItems: any = [];

    QuoteButtonName: string = "Quote";
    BookingButtonName: string = "Book";
    PrepayButtonName: string = "Prepay"
    HideBookingButton: boolean = false;
    HidePrepayButton: boolean = false;

    productQuantityPrecision: number;
    unitPricePrecision: number;
    public pendingAgreementConfig: PendingAgreementConfig = {
        pendingAgreementStatus: false,
        emailType: "",
        pendingBookingStatus: "",
        pendingBookingStatusDescription: "",
        pendingPrepayStatus: "",
        pendingPrepayStatusDescription: "",
        pendingOrderStatus: "",
        pendingOrderStatusDescription: "",
        pendingQuoteStatus: "",
        pendingQuoteStatusDescription: "",
        PendingSignatureRequiredStatus: false,
        ButtonQuote: "Quote",
        ButtonBooking: "Book",
        ButtonPrepay: "Prepay",
        SameBookingNumberConfig: false,
    };
    constructor(public globals: Global, private router: Router,
        public quotesService: QuotesServiceProvider,
        private dataProvider: RouteDataProvider,
        private alertService: AlertService,
        private requestHelper: RequestHelperProvider,
        private appSetting: AppSettingsServiceProvider,
        private itemService: ItemServiceProvider,
        public dialog: MatDialog,
        public titleService: Title,
        private storage: StorageServiceProvider,
        private blockUI: LoadingService
    ) {
        this.blockUI.start();
        let promise = [];
        promise.push(this.getQuotes());
        promise.push(this.getPricision());
        promise.push(this.GetPendingAgreementSettings());
        Promise.all(promise).finally(() => {
            this.blockUI.stop();
        })
    }
    getQuotes(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
                this.quotesService.getQuotes().then(data => {
                    console.log(data.TransactionObject);
                    this.quotes = data.TransactionObject;
                    this.quotes.forEach((quote) => {
                        quote.isExpired = new Date(quote.ExpiryDate) < new Date();
                    });
                    this.quotes.items = [];
                    resolve(true);
                }).catch(error => {
                    Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                    console.log(error);
                    this.alertService.error(error.Message);
                    reject(error);
                });
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        })

    }
    getItems(quote) {
        this.blockUI.start();
        this.selectedItems = [];
        this.quotesService.getItems(quote.BookingId, quote.Location).then((items) => {
            quote.items = items.TransactionObject;
            quote.CalTotalPrice = 0;
            quote.items.forEach(item => {
                item.checked = false;
            });
            this.blockUI.stop();
        }).catch((error) => {
            Sentry.captureMessage("Handled Error" + JSON.stringify(error));
            console.log(error);
            this.blockUI.stop();
            this.alertService.error(error.Message);
        })
    }
    canbeChecked(id): boolean {
        if (this.selectedItems) {
            console.log(this.selectedItems.includes(id));
            return this.selectedItems.includes(id);
        }
        return false;
    }

    userSelectClick(id) {
        if (!this.selectedItems.includes(id))
            this.selectedItems.push(id);
    }

    isSelected(id): boolean {
        return this.selectedItems.includes(id);
    }

    toggle(selectedItem: any, quote: any, event: any): void {
        selectedItem.checked = !selectedItem.checked;

        if (!selectedItem.checked) {
            // this.selectedItems = this.arrayRemove(this.selectedItems, selectedItem.BookingItemId);
            this.selectedItems = this.arrayRemove(this.selectedItems, selectedItem.BookingItemId);
            quote.CalTotalPrice = quote.items.reduce((acc, obj) => acc + (obj.checked ? (obj.Quantity * obj.Price) : 0), 0);

            console.log("selectedItems", this.selectedItems);
        }
        else {
            this.blockUI.start();
            var request = new ItemRequest();
            request.id = selectedItem.ProductId;
            this.itemService.searchItem(request, (i) => {
                let item = i[0];
                this.itemService.IsPriceOverrideAllowed().then((data) => {
                    this.blockUI.stop();
                    this.HideBookingButton = false;
                    this.HidePrepayButton = false;
                    item.maximumPrice = item.maximumPrice == 0 ? Number.MAX_VALUE : item.maximumPrice;
                    if (!selectedItem.IsPriceOveridden && (selectedItem.Price < item.minimumPrice || selectedItem.Price > item.maximumPrice)) {
                        if (data.overrideRestricted) {
                            if (selectedItem.Price < item.minimumPrice) {
                                this.showDialog("Current price is less than minimum price.", selectedItem, item, "Update", event, quote, data)
                                return;
                            } else if (selectedItem.Price > item.maximumPrice) {
                                this.showDialog("Current price is greater than maximum price", selectedItem, item, "Update", event, quote, data);
                                return;
                            }
                        }
                        else if (data.overrideWithWarning) {
                            if (selectedItem.Price < item.minimumPrice) {
                                this.showDialog("Current price is less than minimum price. Override It?", selectedItem, item, "Save and Confirm", event, quote, data)
                                return;
                            } else if (selectedItem.Price > item.maximumPrice) {
                                this.showDialog("Current price is greater than maximum price. Override It?", selectedItem, item, "Save and Confirm", event, quote, data);
                                return;
                            }
                        }
                        else {

                            // if (!this.selectedItems.includes(item.BookingItemId))
                            //     this.selectedItems.push(item.BookingItemId);

                            if (!this.selectedItems.includes(selectedItem.BookingItemId))
                                this.selectedItems.push(selectedItem.BookingItemId);

                            quote.CalTotalPrice = quote.items.reduce((acc, obj) => acc + (obj.checked ? (obj.Quantity * obj.Price) : 0), 0);
                        }
                    }
                    else {

                        // if (!this.selectedItems.includes(item.BookingItemId))
                        //     this.selectedItems.push(item.BookingItemId);

                        if (!this.selectedItems.includes(selectedItem.BookingItemId))
                            this.selectedItems.push(selectedItem.BookingItemId);

                        quote.CalTotalPrice = quote.items.reduce((acc, obj) => acc + (obj.checked ? (obj.Quantity * obj.Price) : 0), 0);

                    }
                    console.log("selectedItems", this.selectedItems);
                });
            }, () => {
                this.blockUI.stop();
            })
        }
    }
    showDialog(message, selectedItem, item, positiveKey, event, quote, restrictedData) {
        let originalPrice = selectedItem.Price;
        const dialogRef = this.dialog.open(ItemOverrideDialog, {
            closeOnNavigation: true,
            width: '500px',
            data: { message: message, item: item, selectedItem: selectedItem, positiveKey: positiveKey, restrictedData: restrictedData },
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                selectedItem.checked = true;
                event.checked = true;
                if (!this.selectedItems.includes(selectedItem.BookingItemId))
                    this.selectedItems.push(selectedItem.BookingItemId);

            }
            else {
                selectedItem.Price = originalPrice;
                selectedItem.checked = false;
                event.checked = false;
                this.selectedItems = this.arrayRemove(this.selectedItems, selectedItem.BookingItemId);
            }
            quote.CalTotalPrice = quote.items.reduce((acc, obj) => acc + (obj.checked ? (obj.Quantity * obj.Price) : 0), 0);
        });
    }
    arrayRemove(arr, value) {
        return arr.filter((ele) => {
            return ele != value;
        });

    }
    book(quote: any, type: String): void {

        if (!this.checkQuoteLocation(quote)) {
            utils.confirmationDialog('Warning', "Location mismatch! Change the Location to " + quote.Location + " to proceed", 'Close', (result) => {
                if (result == 'Close') {

                }

            }, false);
        } else {
            this.dataProvider.storage = { quote: quote, type: type };
            this.router.navigate(['booking/', { from: 'quote' }]);
        }
    }
    editQuote(quote: any): void {

        if (!this.checkQuoteLocation(quote)) {
            utils.confirmationDialog('Warning', "Location mismatch! Change the Location to " + quote.Location + " to proceed", 'Close', (result) => {
                if (result == 'Close') {

                }

            }, false);
        } else {

            quote.items.forEach(item => {
                item.checked = true;
            });
            this.dataProvider.storage = { quote: quote, type: 'quote' };
            this.router.navigate(['booking/', { from: 'quote', id: quote.BookingId }]);
        }
    }

    filterQuote(quotes: any): any {
        if (quotes && quotes.length > 0 && this.quoteSearch && this.quoteSearch.length >= 3) {
            return quotes.filter(q => q.CustomerDescription.toLowerCase().includes(this.quoteSearch.toLowerCase()));
        }
        return quotes;
    }
    deleteQuote(quote) {
        if (!this.checkQuoteLocation(quote)) {
            utils.confirmationDialog('Warning', "Location mismatch! Change the Location to " + quote.Location + " to proceed", 'Close', (result) => {
                if (result == 'Close') {

                }

            }, false);
        } else {

            utils.confirmationDialog('Confirmation', 'Are you sure you want to delete this Quote?', 'Confirm', (result) => {
                if (result == 'Confirm') {
                    this.blockUI.start();
                    let agentType = localStorage.getItem('AgentType');
                    let settings = this.storage.get(StorageKeys.Settings);;
                    let dataSet = this.storage.get(StorageKeys.DataSet);
                    let tenantId = this.storage.getTenantID();
                    let user = JSON.parse(localStorage.getItem("agrisLicense"));

                    let voidBooking = {
                        Id: quote.BookingId,
                        User: user.username,
                        Password: user.password,
                        AgrisSession: user.agrisLicense,
                        SessionId: settings.agentSessionId,
                        TenantId: tenantId,
                        Status: "V",
                        isFromDecline: true
                    };
                    if (quote.BookingNumber) {
                        this.quotesService.voidPendingQuote(voidBooking).then((res: any) => {
                            if (res.TransactionObject) {
                                this.quotesService.deleteQuote(quote.BookingId, user.username).then(() => {
                                    this.alertService.success("Success: Quote deleted successfully.");
                                    this.blockUI.stop();
                                    this.getQuotes();
                                }).catch((e) => {
                                    console.log(e);
                                    Sentry.captureMessage("Handled Error: " + JSON.stringify(e));
                                    this.blockUI.stop();
                                    this.alertService.error(e.Message);
                                })
                            } else {
                                this.blockUI.stop();
                                this.alertService.error("Quote void failed. Error : " + res.ErrorMessage);
                            }
                        });
                    } else {
                        this.quotesService.deleteQuote(quote.BookingId, user.username).then(() => {
                            this.alertService.success("Success: Quote deleted successfully.");
                            this.blockUI.stop();
                            this.getQuotes();
                        }).catch((e) => {
                            console.log(e);
                            Sentry.captureMessage("Handled Error: " + JSON.stringify(e));
                            this.blockUI.stop();
                            this.alertService.error(e.Message);
                        })
                    }
                }
            });
        }
    }

    checkQuoteLocation(quote: any) {
        return quote.Location == JSON.parse(localStorage.settings).locationCode ? true : false;
    }


    GetPendingAgreementSettings(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.blockUI.start();
            this.appSetting.GetAppSettingsFromASR(ASRAppSettings.PendingAgreementsConfiguration).then((response) => {
                let data = response.TransactionObject;
                if (data.length) {

                    let ButtonQuote: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.ButtonQuote);
                    if (ButtonQuote && ButtonQuote.Value) {
                        this.pendingAgreementConfig.ButtonQuote = ButtonQuote.Value;
                        this.QuoteButtonName = ButtonQuote.Value;

                    } else {
                        this.QuoteButtonName = "Quote";
                    }

                    this.titleService.setTitle(this.QuoteButtonName)


                    let ButtonPrepay: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.ButtonPrepay);
                    if (ButtonPrepay && ButtonPrepay.Value) {
                        this.pendingAgreementConfig.ButtonPrepay = ButtonPrepay.Value;
                        this.PrepayButtonName = ButtonPrepay.Value;
                    } else {
                        this.PrepayButtonName = "Prepay";
                    }


                    let ButtonBooking: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.ButtonBooking);
                    if (ButtonBooking && ButtonBooking.Value) {
                        this.pendingAgreementConfig.ButtonBooking = ButtonBooking.Value;
                        this.BookingButtonName = ButtonBooking.Value;
                    } else {
                        this.BookingButtonName = "Booking";
                    }


                    this.HideBookingButton = data.find((x: any) => x.Name == PendingAgreementsConfiguration.HideBookingButton).Value == "true";
                    this.HidePrepayButton = data.find((x: any) => x.Name == PendingAgreementsConfiguration.HidePrepayButton).Value == "true";

                }
                resolve(true);
                // this.blockUI.stop();

            }).catch((error) => {
                if (error) {
                    this.alertService.error(error.Message);
                    reject(error);
                }
                // this.blockUI.stop();
            })
        });
    }

    getPricision(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.blockUI.start();
            this.appSetting.GetDecimalPricision().then((response) => {
                this.unitPricePrecision = response.UnitPricePrecision;
                this.productQuantityPrecision = response.ProductQuantityPrecision;
                resolve(true);
                // this.blockUI.stop();

            }).catch((error) => {
                if (error) {
                    this.alertService.error(error.Message);
                    reject(error);
                }
                // this.blockUI.stop();
            })
        });
    }
}
export interface DialogData {
    message: string;
    item: any;
    selectedItem: any;
    positiveKey: string;
    unitPricePrecision: number;
    productQuantityPrecision: number;
    restrictedData: any;
}
@Component({
    selector: 'item-override-dialog',
    templateUrl: 'item-override-dialog.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ],
})
export class ItemOverrideDialog {
    constructor(
        public dialogRef: MatDialogRef<ItemOverrideDialog>,
        private alertService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private closeDialogService: DialogCloseService

    ) {
        dialogRef.disableClose = true;
        this.closeDialogService.emitRegisterDialog(dialogRef);
    }

    @HostListener('window:keyup.esc') onKeyUp() {
        this.dialogRef.close();
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
    onPositiveClick(): void {
        if (this.data.restrictedData.overrideRestricted) {
            if (this.data.selectedItem.Price < this.data.item.minimumPrice) {
                this.alertService.error("Current price is less than minimum price.", false, true);
                return;
            } else if (this.data.selectedItem.Price > this.data.item.maximumPrice) {
                this.alertService.error("Current price is greater than maximum price", false, true);
                return;
            }
            else {
                this.dialogRef.close(this.data.selectedItem);
            }
        }
        else {
            this.dialogRef.close(this.data.selectedItem);
        }
    }
    checkInput($event, selectedItem) {
        let value = $event.target.value;
        let e = <KeyboardEvent>$event;
        let input = $event.target.name;
        let decimalLimit;
        if (input == "price") {
            decimalLimit = this.data.unitPricePrecision;
        } else if (input == "quantity") {
            decimalLimit = this.data.productQuantityPrecision;
        }
        let decimalPosition = this.countDecimals(value);
        if (decimalPosition > decimalLimit) {
            value = value.substring(0, value.length - (decimalPosition - decimalLimit));
            $event.target.value = value;
            if (input == "price") {
                selectedItem.price = value;
            }
            if (input == "quantity") {
                selectedItem.itemBalance.OnHandQuantity = value;
            }

            e.preventDefault();
        }
    }
    countDecimals(value: any) {
        if (Math.floor(value) === value) return 0;
        if (value.indexOf(".") > -1) {
            return value.toString().split(".")[1].length;
        } else {
            return 0;
        }
    }
}